<template>
    <drop-down v-if="!uiStore.isMobile && ! uiStore.isTablet" :showArrow="false" :endAlign="true" @show="updateNotifications">
        <template #toggle>
            <ui-button color="white" class="notice-container me-1 d-inline-flex align-items-center" aria-label="Notifications">
                <mail-icon :size="20"/>
                <i class="fas fa-circle notice xx-small text-warning" v-if="hasNewNotifications"></i>
            </ui-button>
        </template>
        <template #default>
            <menu-notification-items  @click="mobilePeekOpen=false" @showMessage="showMessageModal"/>
        </template>
    </drop-down>
    <ui-button v-else color="white" class="notice-container me-1 d-inline-flex align-items-center" @click="openMobileNotifications" aria-label="Notifications">
        <mail-icon :size="20"/>
        <i class="fas fa-circle notice xx-small text-warning" v-if="hasNewNotifications"></i>
    </ui-button>

    <peek v-if="uiStore.isMobile || uiStore.isTablet" :open="mobilePeekOpen" @close="mobilePeekOpen=false">
        <template #header>
            Notifications
        </template>
        <template #default>
            <menu-notification-items  @click="mobilePeekOpen=false" @showMessage="showMessageModal"/>
        </template>
    </peek>

    <modal v-if="showMessage" :open="openMessageModal" @close="closeMessageModal">
        <template #default>
            <div class="pre-line" v-if="showMessage.content">
                {{ showMessage.content }}
            </div>
            <div class="pre-line" v-else-if="showMessage.subject">
                {{ showMessage.subject }}
            </div>

            <div class="small text-muted mt-2 border-top">
                {{ showMessageSent }}
            </div>
        </template>
    </modal>
    
</template>

<script type="text/javascript">
    import UIComponents from '@/components/UI/index.vue';
    import Peek from '@/components/Action/Peek.vue';
    import Modal from '@/components/Action/Modal.vue';
    import MenuNotificationItems from '@/components/Layout/Notifications/MenuItems.vue';
    import MenuNotifications from '@/classes/MenuNotifications.js';
    import MailIcon from '@/assets/icons/mail.svg.vue';
    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            Peek,
            Modal,
            MenuNotificationItems,
            MailIcon,
            ...UIComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                todo: MenuNotifications.todo,
                messages: MenuNotifications.todo,
                lastOpened: MenuNotifications.lastOpened,

                mobilePeekOpen: false,

                openMessageModal: null,
                showMessage: null,
            };
        },

        computed: {

            hasNewNotifications() {
                // check if we have any todo items
                if (this.todo) {
                    for (const [key, value] of Object.entries(this.todo)) {
                        if (
                            (key == 'id') ||
                            (key == 'apiReference') ||
                            (key == 'apiEndPoint') ||
                            (key == 'reference') ||
                            (key == 'pulledAt') ||
                            (key.substring(0, 1) == '_')
                        ) {
                            continue;
                        }

                        if ((value instanceof Array) && (value.length)) {
                            return true;
                        }
                        else if (value) {
                            return true;
                        }
                    }
                }

                if ((this.messages) && (this.messages.length)) {
                    if (!this.lastOpened) {
                        return true;
                    }
                    // find if we have a message after the last opened
                    else {
                        for (let i=0; i<this.messages.length; i++) {
                            if (this.messages[i].clicked) continue;

                            let sentOnTime = (this.messages[i].sentOn) ? this.messages[i].sentOn.time : Date.now();
                            if (sentOnTime > this.lastOpened.time) {
                                return true;
                            }
                        }
                    }
                }

                return false;
            },
            
            showMessageSent() {
                if (this.showMessage.sentOn) {
                    return this.showMessage.sentOn.format('n/j/Y g:i a');
                }
                else {
                    return 'Now';
                }
            },
        },

        methods: {
            updateNotifications() {
                MenuNotifications.request(true);
            },

            openMobileNotifications() {
                this.mobilePeekOpen = !this.mobilePeekOpen;
                if (this.mobilePeekOpen) {
                    MenuNotifications.request(true);
                }
            },

            showMessageModal(message) {
                this.openMessageModal = true;
                this.showMessage = message;
            },

            closeMessageModal() {
                this.showMessage = null;
                this.openMessageModal = null;
            }
        },
    }
</script>